import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import * as Renders from "../../../../component/AdvancedFiltersRenders";
import { useSetRecoilState } from "recoil";
import { STATE_ACTIVE_FILTERS } from "../atoms/CollectionDetailAtoms";
import {
    ID_FILTER_AMOUNT_FROM,
    ID_FILTER_AMOUNT_TO,
    ID_FILTER_DEBTOR_NAME,
    ID_FILTER_IBAN,
    ID_FILTER_MANDATE_ID,
    ID_FILTER_REFERENCE,
    ID_FILTER_STATUS,
    ID_FILTER_SUBSCRIPTION_DATE_FROM,
    ID_FILTER_SUBSCRIPTION_DATE_TO,
    STATUSES
} from "../../constants/CollectionDetailConstants";
import AdvancedFilter from "../../../../component/AdvancedFilter";
import { addFilter } from "../../../../utils/FilterUtils";

function ThresholdConfigurationFilter() {
    const { t } = useTranslation("finance", { keyPrefix: "sdd.collections" });

    const setFilters = useSetRecoilState(STATE_ACTIVE_FILTERS);
    const schema = Yup.object().shape({
        [ID_FILTER_DEBTOR_NAME]: Yup.string().max(
            128,
            t("filters.errors.invalid-length")
        ),
        [ID_FILTER_MANDATE_ID]: Yup.string().max(
            128,
            t("filters.errors.invalid-length")
        ),
        [ID_FILTER_AMOUNT_FROM]: Yup.number().transform((value, originalValue) => {
            return originalValue.trim() === '' ? undefined : parseFloat(originalValue);
        }).test('amount', t('filters.errors.invalid-amount'), function (value) {
            const toValue = this.parent[ID_FILTER_AMOUNT_TO];
            return toValue === undefined || value === undefined || value <= toValue;
        }).nullable(),
        [ID_FILTER_AMOUNT_TO]: Yup.number().transform((value, originalValue) => {
            return originalValue.trim() === '' ? undefined : parseFloat(originalValue);
        }).test('amount', t('filters.errors.invalid-amount'), function (value) {
            const fromValue = this.parent[ID_FILTER_AMOUNT_FROM];
            return fromValue === undefined || value === undefined || value >= fromValue;
        }).nullable(),
        [ID_FILTER_SUBSCRIPTION_DATE_FROM]: Yup.date().nullable().test("testFrom", t('filters.errors.invalid-subscription-date-from'), (value, context) => {
            console.log(context)
            return !value || !context.parent.subscriptionTo || (value <= context.parent.subscriptionTo);
        }).test('date-range', t('filters.errors.invalid-report-date-from'), function (value) {
            const { dateTo } = this.parent;
            return !value || !dateTo || value <= dateTo;
        }).typeError(t('filters.errors.invalid-report-date-from')),
        [ID_FILTER_SUBSCRIPTION_DATE_TO]: Yup.date().nullable().test("testTo", t('filters.errors.invalid-subscription-date-to'), (value, context) => {
            return !value || !context.parent.subscriptionFrom || (value >= context.parent.subscriptionFrom);
        }).test('date-range', t('filters.errors.invalid-report-date-to'), function (value) {
            const { dateFrom } = this.parent;
            return !value || !dateFrom || value >= dateFrom;
        }).typeError(t('filters.errors.invalid-report-date-to'))

    });

    const defaultValues = {
        [ID_FILTER_DEBTOR_NAME]: "",
        [ID_FILTER_MANDATE_ID]: "",
        [ID_FILTER_STATUS]: "",
        [ID_FILTER_AMOUNT_FROM]: "",
        [ID_FILTER_AMOUNT_TO]: "",
        [ID_FILTER_REFERENCE]: "",
        [ID_FILTER_IBAN]: "",
        [ID_FILTER_SUBSCRIPTION_DATE_FROM]: null,
        [ID_FILTER_SUBSCRIPTION_DATE_TO]: null,

    };

    const fields = {
        main: {
            [ID_FILTER_DEBTOR_NAME]: Renders.renderTextField(
                ID_FILTER_DEBTOR_NAME,
                t("filters." + ID_FILTER_DEBTOR_NAME)
            ),
            [ID_FILTER_MANDATE_ID]: Renders.renderTextField(
                ID_FILTER_MANDATE_ID,
                t("filters." + ID_FILTER_MANDATE_ID)
            ),
            [ID_FILTER_STATUS]: Renders.renderSelect(
                ID_FILTER_STATUS,
                t("filters." + ID_FILTER_STATUS),
                STATUSES.map((x) => {
                    return { ...x, label: t(x.label) };
                })
            )
        },
        adv: {
            [ID_FILTER_AMOUNT_FROM]: Renders.renderTextField(
                ID_FILTER_AMOUNT_FROM,
                t("filters." + ID_FILTER_AMOUNT_FROM)
            ),
            [ID_FILTER_AMOUNT_TO]: Renders.renderTextField(
                ID_FILTER_AMOUNT_TO,
                t("filters." + ID_FILTER_AMOUNT_TO)
            ),
            [ID_FILTER_REFERENCE]: Renders.renderTextField(
                ID_FILTER_REFERENCE,
                t("filters." + ID_FILTER_REFERENCE)
            ),
            [ID_FILTER_IBAN]: Renders.renderTextField(
                ID_FILTER_IBAN,
                t("filters." + ID_FILTER_IBAN)
            ),
            [ID_FILTER_SUBSCRIPTION_DATE_FROM]: Renders.rendereDatePickerTo(
                ID_FILTER_SUBSCRIPTION_DATE_FROM,
                t("filters." + ID_FILTER_SUBSCRIPTION_DATE_FROM)
            ),
            [ID_FILTER_SUBSCRIPTION_DATE_TO]: Renders.rendereDatePickerTo(
                ID_FILTER_SUBSCRIPTION_DATE_TO,
                t("filters." + ID_FILTER_SUBSCRIPTION_DATE_TO)
            )
        }
    };

    const submit = (data: any) => {
        Object.keys(defaultValues)
            .forEach((param) => {
                addFilter(setFilters, param, data[param]);
            });
    };

    const reset = () => {
        setFilters([]);
    };

    return (
        <AdvancedFilter
            schema={schema}
            mainFields={fields.main}
            fields={fields.adv}
            defaultValues={defaultValues}
            onSubmit={submit}
            onReset={reset}

        />
    );
}

export default ThresholdConfigurationFilter;
